import { render, staticRenderFns } from "./management-account-edit-form.vue?vue&type=template&id=1076e5da&"
import script from "./management-account-edit-form.vue?vue&type=script&lang=js&"
export * from "./management-account-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports